import { PropsWithChildren } from 'react'

export const SectionGroup = (props: PropsWithChildren) => {
  return <div className="flex flex-col gap-spacing8">{props.children}</div>
}
